import { baseApi } from "./baseApi";

const retailPipelineApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getRetailPipeline: builder.query({
      query: () => ({
        url: "/retail-pipeline",
        method: "GET",
      }),
      providesTags: ["RetailPipeline"],
    }),
  }),
});

export default retailPipelineApi;
